import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './components/User/Login.vue'
import Register from './components/User/Register.vue'
import Profile from './components/User/Profile.vue'
import AddressBook from './components/AddressBook/AddressBook.vue'
import Address from './components/AddressBook/Address.vue'
import Confirm from './components/Shared/Confirm.vue'
import AuthGuard from './guards/auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/address-book',
      name: 'addressBook',
      component: AddressBook,
      beforeEnter: AuthGuard
    },
    {
      path: '/add-address',
      name: 'addAddress',
      component: Address,
      beforeEnter: AuthGuard
    },
    {
      path: '/edit-address/:id',
      name: 'editAddress',
      props: true,
      component: Address,
      beforeEnter: AuthGuard
    },
    {
      path: '/delete-record/:id',
      name: 'deleteRecord',
      props: true,
      component: Confirm,
      beforeEnter: AuthGuard
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
